module.exports = __webpack_public_path__ + "img/icons-6.4f75b263.png";